import { render } from "./AcademicWeekdayPrimary.vue?vue&type=template&id=a0af0aba&scoped=true"
import script from "./AcademicWeekdayPrimary.vue?vue&type=script&lang=js"
export * from "./AcademicWeekdayPrimary.vue?vue&type=script&lang=js"

import "./AcademicWeekdayPrimary.vue?vue&type=style&index=0&id=a0af0aba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0af0aba"]])

export default __exports__